import { render, staticRenderFns } from "./Alertas.vue?vue&type=template&id=58e7c12a&scoped=true"
import script from "./Alertas.vue?vue&type=script&lang=js"
export * from "./Alertas.vue?vue&type=script&lang=js"
import style0 from "./Alertas.vue?vue&type=style&index=0&id=58e7c12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e7c12a",
  null
  
)

export default component.exports